// extracted by mini-css-extract-plugin
export default {"breedText":"_XwXhh","breedButton":"sa_Inf"};